"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientChats = void 0;
const IGroupChats_1 = require("./IGroupChats");
const models_1 = require("../../models");
const utils_1 = require("../../utils");
const mappers_1 = require("../../mappers");
const EmrParsedDataMapper_1 = require("../../mappers/EmrParsedDataMapper");
const emr_parser_1 = require("@home-health-notify/emr-parser");
class PatientChats extends IGroupChats_1.IGroupChats {
    constructor(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage) {
        super(httpAdapter, organizationUser, socketAdapter, config, userDirectory, hhnStorage);
        this._advanceSearchClinicianList = {
            nearbyPatients: [],
            users: [],
            limit: utils_1.HHNConstants.GROUP_PAGINATION_LIMIT,
            page: 0,
            total: 0,
            hasNext: true,
        };
    }
    init() {
        super.init();
        this.removeListeners.push(this.hideChatListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.unHideChatListener(() => {
            this.notifyChange();
        }));
        this.removeListeners.push(this.addChatListener(() => {
            this.notifyChange();
        }));
    }
    getChatsStorage() {
        return this.hhnStorage.chatsStorage;
    }
    getGroupType() {
        return models_1.GROUP_TYPE.PATIENT;
    }
    emrDataMapper(data) {
        const mappedEmrData = (0, EmrParsedDataMapper_1.emrParsedDataMapper)(data);
        return (0, mappers_1.groupInfoMapper)(mappedEmrData, this.userDirectory, this.organizationUser, this.httpAdapter, this.socketAdapter);
    }
    registerEmrParser(cb) {
        var _a;
        const patientEmrParser = new emr_parser_1.PatientEmrParser();
        const emrId = (_a = this.organizationUser.getOrganization().settings) === null || _a === void 0 ? void 0 : _a.emrId;
        if (!emrId)
            return;
        patientEmrParser.register(emrId, (data) => __awaiter(this, void 0, void 0, function* () {
            // 1. Regex extraction (fast, deterministic, ~10ms). Try this first —
            //    it handles 99% of pastes for supported EMRs.
            try {
                const mappedData = this.emrDataMapper(data);
                cb(mappedData, null, null, null);
                return;
            }
            catch (regexError) {
                // console.warn (not console.error) so Sentry's
                // captureConsoleIntegration({levels:["error"]}) doesn't produce a
                // duplicate Sentry event alongside the intentional error at the
                // bottom of this function.
                console.warn("[emr] regex extraction failed, trying LLM fallback", regexError);
            }
            // 2. LLM fallback — only fires when a default LLM client has been
            //    injected at bootstrap (dev builds only; NODE_ENV guard in
            //    apps/web-app/src/index.tsx). Prod skips this branch silently.
            if (data.pastedData) {
                const llmResult = yield this.tryLlmExtraction(emrId, data.pastedData);
                if (llmResult) {
                    try {
                        const mappedData = this.emrDataMapper(llmResult);
                        cb(mappedData, null, null, null);
                        return;
                    }
                    catch (llmMapError) {
                        console.warn("[emr] LLM result mapping failed; both paths exhausted", llmMapError);
                    }
                }
            }
            // 3. Both regex and LLM failed. One console.error → one Sentry event.
            console.error("EMR data mapping failed — regex + LLM fallback both exhausted");
            cb(null, new Error("EMR data could not be parsed"), data.pastedData, data.pasteTargetElement);
        }));
        return () => patientEmrParser.unRegister();
    }
    tryLlmExtraction(emrId, pastedData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // Dynamic import so domain doesn't take a hard dep on ai-features
                // at module-load time — only when LLM is actually requested.
                const aiFeatures = yield Promise.resolve().then(() => __importStar(require("@home-health-notify/ai-features")));
                // Build an inline ILlmClient that routes through the shared
                // httpAdapter — reuses the app's AuthInterceptor so auth is
                // handled automatically. No separate token plumbing needed.
                const httpAdapter = this.httpAdapter;
                const llmClient = {
                    createMessage(req) {
                        return __awaiter(this, void 0, void 0, function* () {
                            var _a, _b, _c, _d, _e;
                            // 503 = transient upstream problem (backend code "upstream-timeout" /
                            // "upstream-unavailable") and is SAFE TO RETRY. Everything else —
                            // 400/401/413 (client) and 500 "internal-error" (backend) — is NOT
                            // retryable, so rethrow immediately. One bounded retry keeps the
                            // paste UX snappy; extractEmr treats a final throw as client-error
                            // and the caller falls back to the hand-written parser.
                            const MAX_ATTEMPTS = 2;
                            const RETRY_DELAY_MS = 300;
                            let httpRes;
                            for (let attempt = 1;; attempt++) {
                                try {
                                    httpRes = yield httpAdapter.post("/api/v1/llm/messages", Object.assign({ model: req.model, maxTokens: req.maxTokens, system: req.system, messages: req.messages, tools: req.tools }, (req.toolChoice ? { toolChoice: req.toolChoice } : {})), { timeout: req.timeoutMs });
                                    break;
                                }
                                catch (err) {
                                    const status = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.status;
                                    if (status === 503 && attempt < MAX_ATTEMPTS) {
                                        yield new Promise(resolve => setTimeout(resolve, RETRY_DELAY_MS));
                                        continue;
                                    }
                                    throw err;
                                }
                            }
                            // axios wraps the backend response body at .data. The backend
                            // returns { data: { content, stopReason, usage } }, hence .data.data.
                            // Content is an array of Bedrock Converse blocks: a text block is
                            // { text }, a tool-use block is { toolUse: { toolUseId, name, input } }.
                            // We only need the first tool-use block.
                            const body = httpRes.data;
                            let toolUse = null;
                            const content = (_b = body === null || body === void 0 ? void 0 : body.data) === null || _b === void 0 ? void 0 : _b.content;
                            if (Array.isArray(content)) {
                                for (const block of content) {
                                    if (block === null || block === void 0 ? void 0 : block.toolUse) {
                                        toolUse = {
                                            toolUseId: block.toolUse.toolUseId,
                                            name: block.toolUse.name,
                                            input: block.toolUse.input,
                                        };
                                        break;
                                    }
                                }
                            }
                            return {
                                toolUse,
                                stopReason: (_d = (_c = body === null || body === void 0 ? void 0 : body.data) === null || _c === void 0 ? void 0 : _c.stopReason) !== null && _d !== void 0 ? _d : null,
                                usage: (_e = body === null || body === void 0 ? void 0 : body.data) === null || _e === void 0 ? void 0 : _e.usage,
                            };
                        });
                    },
                };
                const start = Date.now();
                const result = yield aiFeatures.extractEmr(pastedData, emrId, llmClient);
                console.info(`[emr] LLM extraction succeeded in ${Date.now() - start}ms`);
                // The LLM extractor's address shape is { placeName, apartmentNo }
                // while domain's IEmrParsedData has the full {geoLocation, lat, lng,
                // placeName} shape. The geo fields are populated downstream by
                // enrichAddress, so at runtime the mapper handles either shape.
                // Cast through unknown to satisfy the type checker.
                return result;
            }
            catch (err) {
                console.warn("[spike] LLM extraction failed; falling back to hand-written parser", err);
                return null;
            }
        });
    }
    addChat(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const requestPayload = Object.assign(Object.assign({}, data), { type: models_1.GROUP_TYPE.PATIENT });
                yield this.httpAdapter.getChatAdapter().addGroup(requestPayload);
            }
            catch (e) {
                const apiError = utils_1.ApiError.fromAxiosError(e);
                throw apiError !== null && apiError !== void 0 ? apiError : new utils_1.HhnException(e);
            }
        });
    }
    createNewEpisode(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const requestPayload = Object.assign(Object.assign({}, data), { type: models_1.GROUP_TYPE.PATIENT });
                yield this.httpAdapter.getChatAdapter().createNewEpisode(requestPayload);
            }
            catch (e) {
                throw new utils_1.HhnException(e);
            }
        });
    }
    getAdvanceSearchPayload() {
        const { page = 0 } = this.advanceSearchClinicianList;
        return {
            pageNo: page + 1,
            limit: 20,
            userType: models_1.USER_TYPE.USER,
        };
    }
    get advanceSearchClinicianList() {
        return this._advanceSearchClinicianList;
    }
    fetchAdvanceSearchClinicianList(advanceSearchPayload, context) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.advanceSearchClinicianList.hasNext) {
                const advanceSearchResponse = yield this.httpAdapter
                    .getChatAdapter()
                    .advanceSearch(Object.assign(Object.assign({}, advanceSearchPayload), this.getAdvanceSearchPayload()), context);
                if (!advanceSearchResponse.isAborted) {
                    const advanceSearchClinicianData = yield (0, mappers_1.advanceSearchMapper)(advanceSearchResponse.data, this.userDirectory);
                    this._advanceSearchClinicianList = Object.assign(Object.assign({}, advanceSearchClinicianData), { page: advanceSearchClinicianData.page, nearbyPatients: advanceSearchClinicianData.nearbyPatients, users: this.mergeUsers(this.advanceSearchClinicianList.users, advanceSearchClinicianData.users) });
                    this.notifyChange();
                }
            }
        });
    }
    resetAdvanceSearchClinicianList() {
        this._advanceSearchClinicianList = {
            nearbyPatients: [],
            users: [],
            limit: utils_1.HHNConstants.GROUP_PAGINATION_LIMIT,
            page: 0,
            total: 0,
            hasNext: true,
        };
        this.notifyChange();
    }
    mergeUsers(existingUsers, newUsers) {
        const usersMap = new Map();
        for (const user of existingUsers) {
            usersMap.set(user.id, user);
        }
        for (const user of newUsers) {
            usersMap.set(user.id, user);
        }
        return Array.from(usersMap.values());
    }
    updateVisibleToPatient(data) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.groupChatInfoSocketUpdateObservable.updateVisibleToPatient(data);
        });
    }
}
exports.PatientChats = PatientChats;
